import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BRAND } from "@/lib/content";
import { BrandWordmark } from "@/components/landing/BrandWordmark";

/**
 * Minimal shell layout for non-landing pages (Insights, Legal, Privacy).
 * Keeps the visual identity (brand wordmark, dark palette) but with
 * a stripped-down navigation focused on "back to home".
 */
const PageShell = ({ children, testid }) => {
  return (
    <main
      data-testid={testid}
      className="min-h-screen bg-[#0B0410] text-[#F9F6F0] font-sans-emb"
    >
      {/* Top bar */}
      <header className="border-b border-white/10 bg-[#0B0410]/95 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
          <Link
            to="/"
            data-testid="page-shell-home-link"
            className="flex items-center gap-3 group"
          >
            <img
              src={BRAND.logoWhite}
              alt="EMB Consulting Group"
              className="h-12 w-12 object-contain shrink-0"
            />
            <BrandWordmark
              title="EMB Consulting Group"
              subtitle="Financial Planning · Regular Savings"
              containerClassName="hidden sm:inline-block leading-tight"
              titleClassName="font-display text-[#F9F6F0] text-lg tracking-tight"
              subtitleClassName="text-[#A397B4] uppercase mt-0.5"
              subtitleStyle={{
                fontSize: "0.5rem",
                lineHeight: "1",
                letterSpacing: "0.03em",
              }}
            />
          </Link>
          <Link
            to="/"
            data-testid="page-shell-back"
            className="inline-flex items-center gap-2 text-xs tracking-luxury uppercase text-[#F9F6F0]/70 hover:text-[#E6D5B8] transition-colors"
          >
            <ArrowLeft size={14} />
            <span>Inicio</span>
          </Link>
        </div>
      </header>

      <div className="relative">{children}</div>

      {/* Mini footer */}
      <footer className="border-t border-white/10 bg-[#050208] py-10 mt-16">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#A397B4]/80">
          <div>
            © {new Date().getFullYear()} {BRAND.name}. Todos los derechos reservados.
          </div>
          <nav className="flex gap-6">
            <Link
              to="/insights"
              className="hover:text-[#E6D5B8] transition-colors"
            >
              Insights
            </Link>
            <Link
              to="/legal"
              className="hover:text-[#E6D5B8] transition-colors"
            >
              Aviso Legal
            </Link>
            <Link
              to="/privacidad"
              className="hover:text-[#E6D5B8] transition-colors"
            >
              Privacidad
            </Link>
          </nav>
        </div>
      </footer>
    </main>
  );
};

export default PageShell;
